import { apiRequest } from '../api';

// The chart of accounts' change log (COA-10) — the shapes server/src/db/coaLog.ts returns, field for
// field, and the one admin call (Admin → Chart template, behind requireAuth + requireAdmin). The one
// account's history the chart screen shows goes through api.acctAccountHistory in src/utils/api.ts.

export type ChartLogRow = {
  id: number; at: number; scope: string; clientId: string; entityId: string; code: string; action: string;
  field: string; oldValue: any; newValue: any; snapshot: Record<string, any> | null; reason: string;
  actorId: string; actorName: string; source: string; opId: string;
};
/** b13 S2 (B13-14): a parent account a log row names by id, as the server looked it up in that row's own client. */
export type ParentRef = { code: string; nameTh: string };
export type AccountHistory = {
  account: { id: string; clientId: string; code: string; nameTh: string; nameEn: string };
  history: ChartLogRow[];
  /** Every parent_id the rows name, in this account's client (a stray id of another client's is absent: it prints raw). */
  refs?: Record<string, ParentRef>;
};
export type ReplayMismatch = { id: string; code: string; clientId: string; why: 'no_history' | 'removed' | 'differs' | 'missing' | 'gap' | 'recreated'; columns: string[] };
export type ChangeLogPage = {
  rows: (ChartLogRow & { clientName: string })[]; total: number; page: number; limit: number;
  /** b13 S2: the parents the page's rows name — PER CLIENT (refs[clientId][accountId]), each looked up in its row's client. */
  refs?: Record<string, Record<string, ParentRef>>;
  filters: { clientId: string; scope: string };
  clients: { id: string; name: string; n: number }[];
  scopes: { scope: string; n: number }[];
  integrity: {
    baselines: number; baselineLate: number;
    replay: { accounts: number; mismatched: number; noHistory: number; sample: ReplayMismatch[] };
    columns: { untracked: string[]; missing: string[] };
  };
};

export const coaLogApi = {
  changes: (f: { clientId?: string; scope?: string; page?: number } = {}): Promise<ChangeLogPage> => {
    const qs = new URLSearchParams();
    if (f.clientId) qs.set('clientId', f.clientId);
    if (f.scope) qs.set('scope', f.scope);
    if (f.page && f.page > 1) qs.set('page', String(f.page));
    const q = qs.toString();
    return apiRequest('GET', `/admin/coa-master/changes${q ? `?${q}` : ''}`);
  },
};
